import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp, FlipProp } from '@fortawesome/fontawesome-svg-core'

import { Button } from './Button'
import { TooltipPlacement } from '../../Tooltip'

interface IconButtonProps {
  label?: JSX.Element
  dataTest?: string
  iconName?: IconProp
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  isActive?: boolean
  tooltipText?: string
  className?: string
  notificationText?: number | string
  iconStyle?: { flip: FlipProp }
  isLoading?: boolean
  tooltipPlacement?: TooltipPlacement
}

export const IconButton: React.FC<IconButtonProps> = ({
  label,
  dataTest,
  disabled,
  isActive,
  iconName,
  className,
  iconStyle,
  tooltipText,
  tooltipPlacement,
  notificationText,
  onClick,
  isLoading
}) => {
  return (
    <IconButtionWrapper
      tooltipText={tooltipText}
      disabled={disabled}
      onClick={onClick}
      isActive={isActive}
      isLoading={isLoading}
      dataTest={dataTest}
      className={className}
      tooltipPlacement={tooltipPlacement}
      notificationText={notificationText}
      text={
        !isLoading && (
          <>
            {label} {iconName && <FontAwesomeIcon icon={iconName} flip={iconStyle?.flip} />}
          </>
        )
      }
    />
  )
}

const IconButtionWrapper = styled(Button)`
  padding: 0;
`
